import SocialMediaShare from "@components/SocialMediaShare/SocialMediaShare";
import { CMSSocialMediaProps } from "@jwm/types/CMSSocialMediaProps";
import React from "react";

import style from "../style.module.scss";

export const SocialMediaBlock = (props: {
    pageTitle: string;
    socialMediaOptions: CMSSocialMediaProps;
}): JSX.Element => {
    const { pageTitle, socialMediaOptions } = props;
    return (
        <>
            {socialMediaOptions?.platforms?.length > 0 && (
                <div className={style.socialShareBlock}>
                    <SocialMediaShare socialmediadata={socialMediaOptions} placement={`page:${pageTitle}`} />
                </div>
            )}
        </>
    );
};
